import { useEffect, useRef } from "react";
import { Grid, Switch } from "@mui/material";
import { Form, Formik } from "formik";
import FormikControl from "src/components/formik/FormikControl";
import { ContainedButton } from "src/components/button-group";
import MaterialReactTable from "material-react-table";
import {
  addBranch,
  fetchAdminLocations,
  updateBranch,
} from "src/slices/configuration/thunks";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "src/store";
import { toastMessage } from "src/slices/commonSlice";

// Form Inital Values
const formInitialValue = {
  name: "",
  shortCode: "",
  id: 0,
};

const BranchManagement = () => {
  const formikRef = useRef(null);
  const dispatch = useDispatch<AppDispatch>();
  const locations = useSelector(
    (state: any) => state.configuration.adminLocations
  );

  const onClickAddBranch = async (values) => {
    if (values.name !== "") {
      const response = await dispatch(
        addBranch({ name: values.name, shortCode: values.shortCode })
      );
      if (response.payload) {
        dispatch(fetchAdminLocations());
        formikRef.current.setFieldValue("name", "");
        formikRef.current.setFieldValue("shortCode", "");
      }
    } else {
      dispatch(
        toastMessage({
          error: true,
          message: "Service cannot be empty",
        })
      );
    }
  };

  const handleSwitchChange = async (branchId, isActive) => {
    const response = await dispatch(updateBranch({ branchId, isActive }));
    if (response.payload) {
      dispatch(fetchAdminLocations());
      formikRef.current.setFieldValue("name", "");
    }
  };

  useEffect(() => {
    dispatch(fetchAdminLocations());
    // eslint-disable-next-line
  }, []);

  return (
    <Formik
      initialValues={formInitialValue}
      innerRef={formikRef}
      onSubmit={(values) => {
        onClickAddBranch(values);
      }}
    >
      {({ values, touched, errors, getFieldProps }) => (
        <Form id="Configuration">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={3} pb={3} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <FormikControl
                    control="InputField"
                    name="name"
                    label={"Branch Name"}
                    required
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                    {...getFieldProps("name")}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikControl
                    control="InputField"
                    name="shortCode"
                    label={"Short Code"}
                    required
                    error={Boolean(touched.shortCode && errors.shortCode)}
                    helperText={touched.shortCode && errors.shortCode}
                    {...getFieldProps("shortCode")}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ContainedButton size="medium" type="submit">
                    Add Branch
                  </ContainedButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MaterialReactTable
                    columns={[
                      {
                        accessorKey: "id",
                        header: "Branch Id",
                        size: 100,
                      },
                      {
                        accessorKey: "name",
                        header: "Name",
                        size: 100,
                      },
                      {
                        accessorKey: "shortCode",
                        header: "Short Code",
                        size: 100,
                      },
                      {
                        accessorKey: "isActive",
                        header: "Enabled",
                        size: 100,
                        Cell: ({ row }) => (
                          <Switch
                            checked={row.original.isActive}
                            onChange={(e) =>
                              handleSwitchChange(
                                row.original.id,
                                e.target.checked
                              )
                            }
                            color="primary"
                          />
                        ),
                      },
                    ]}
                    data={locations?.map((location) => ({
                      id: location.id,
                      name: location.name,
                      shortCode: location.shortCode,
                      isActive: location.isActive,
                    }))}
                    initialState={{
                      density: "compact",
                      pagination: { pageSize: 5, pageIndex: 0 },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default BranchManagement;
